<style lang="less" scoped>
@import "./index.less";
.home-container {
  background-color: #f0f0f0;
  /deep/ .el-menu-item {
    padding: 0 10px;
    width: 20%;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
  /deep/ .is-active {
    border-bottom: 2px solid #000;
    font-weight: bold;
  }
  .top-banner {
    width: 100%;
    margin: 0 auto;

    .banner-box img {
      width: 100%;
      height: auto;
    }
  }
  .album-tag.el-tag {
    position: absolute;
    left: 10px;
    top: 10px;
    height: 24px;
    line-height: 22px;
    color: #ffffff;
    background-color: #ff0000;
    border: none;
    border-radius: 0;
    font-size: 12px;
    padding: 0 16px;
    font-weight: 800;
  }
  .album-tag.tag-special {
    background-color: #007eff;
  }
  .product-box {
      .image-watermark {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    .product-info {
      background: white;
      padding: 0.5rem;
      position: relative;
      .product-name {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.65);
      }


      .product-market-price {
        font-size: 14px;
        text-decoration: line-through;
        text-decoration-color: #c30d24;
        line-height: 30px;
        color: rgba(0, 0, 0, 0.65);
      }

      .product-pay-price {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .product-price {
        font-size: 18px;
        color: #c30d24;
        font-weight: 700;
      }

      .product-cart-icon {
        font-size: 20px;
        margin-left: 6px;
      }
    }
  }
  .swiper-container {
    width: 100%;
    height: auto;
  }  
}
</style>
<template>
  <div class="home-container">
    <!-- <div class="top-banner">
      <swiper
        class="banner-box"
        @transitionStart="bannerChange"
        :options="bannerOption"
        ref="bannerBox"
      >
        <swiper-slide
          class="swiper-no-swiping"
          v-for="(banner, index) in topBanners"
          :key="index"
        >
          <a
            :href="banner.url"
            v-if="banner.url"
          >
            <img
              style="width: 100%;object-fit: cover;"
              :src="banner.pathUrl"
              :alt="banner.name"
            >
          </a>
          <img
            style="width: 100%;object-fit: cover;"
            v-else
            :src="banner.pathUrl"
            :alt="banner.name"
          >
        </swiper-slide>
      </swiper>
    </div> -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(banner, index) in topBanners" :key="index">
            <!-- <a :href="banner.url" v-if="banner.url"> -->
              <img style="width: 100%;object-fit: cover;" :src="banner.pathUrl" :alt="banner.name">
            <!-- </a> -->
          </div>
          <!-- <div class="swiper-slide">Slide 1</div>
          <div class="swiper-slide">Slide 2</div>
          <div class="swiper-slide">Slide 3</div> -->
      </div>
      <div class="swiper-page">{{ swiperIndexString }}</div>
    </div>
    <div style="padding:0 10px;background:white">
      <el-menu mode="horizontal" :default-active="activeCate" @select="handleSelect">
        <el-menu-item index="0" v-if="weekMain.isShow">本月主打</el-menu-item>
        <el-menu-item v-for="(cate, index) in productCates" v-if="cate.isShow" :key="index" :index="String(cate.id)">{{ cate.content.title }}</el-menu-item>
      </el-menu>
    </div>
    <img v-if="cateBanner" :src="cateBanner" style="width:100%;" />

    <el-row class="product-box" v-if="cateProduct && cateProduct.length" style="padding: 0.25rem 0.25rem;">
      <el-col :span="12" style="padding: 0.25rem 0.25rem;" v-for="(item, index) in cateProduct" :key="index">
        <component :is="item.link ? 'router-link' : 'span'" :to="item.link || ''" :target="item.target || '_self'">
          <div class="flex col" style="position: relative;background:white">
            <el-tag v-if="$enums.productMark.label(item.tag)" :class="`album-tag tag-${item.tag}`">{{item.tag|enums('productMark')}}</el-tag>
            <img class="image-watermark" v-if="item.watermark" :src="item.watermarkImage">
            <img class="image-fluid" :src="item.img|imgUrl" v-if="item.img" :alt="item.title" v-reload>
            <div class="flex col product-info">
              <div class="product-name ellipsis">{{item.title}}</div>
              <div class="product-market-price">¥ {{item.marketPrice}}</div>
              <div class="product-pay-price">
                <span class="product-price">¥ {{item.salePrice}}</span>
                <span @click.stop.prevent="addCart(item.productInfo)">
                  <svg-icon class="product-cart-icon" :icon-class="'cart-circle'"/>
                </span>
              </div>
            </div>
          </div>
        </component>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Swiper from 'swiper'
import lodash from 'lodash'
import 'swiper/dist/css/swiper.css'

import moment from 'moment'
import _ from 'lodash'
import { isSellOut } from "@/helpers";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { createNamespacedHelpers } from 'vuex'
import CartOperator from '@/mixins/CartOperator'

const { mapState: pageSettingMapState } = createNamespacedHelpers('activityPageSettings')
const sallOutImagePath = require('@/assets/watermark/sell-out.png')

export default {
  mixins: [CartOperator],
  data: function () {
    return {
      swiperContainer: null,
      bannerOption: {
        initialSlide: 0,
        autoplay: true,
        // loop: true,
        speed: 1000,
      },
      bannerNameOption: {
        initialSlide: 0,
        loop: false,
        slidesPerView: 5,
        speed: 150,
      },
      activeCate: '0',
      cateSettings: [],
      cateProducts: [],
      weekMain: {},
      products: [],
      showIndex: 0,
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...pageSettingMapState([
      'homeSettings'
    ]),
    swiperIndexString() {
      
    },
    cateProduct() {
      if (this.activeCate == '0') {
        return this.weekMain.products
      } else {
        const item = lodash.find(this.productCates, item => {
          return item.id == this.activeCate
        })
        if (item && item.isShowProduct && item.content && item.content.mainProducts) {
          console.log(item.content.mainProducts)
          return this.getCateProduct(item.content.mainProducts)
        }
      }
    },
    cateBanner() {

      if (this.activeCate != '0') {
        const item = lodash.find(this.productCates, item => {
          return item.id == this.activeCate
        })
        if (item && item.content && item.isShowBanner && item.content.bannerPath) {
          return item.content.bannerPath
        }
      }
    },
    topBanners() {
      return this.$store.state.activityBanners.collection ? this.$store.state.activityBanners.collection : []
    },
    productCates() {
      const cates = []
      const peoductKeys = ['watch', 'digital-piano', 'e-education', 'calculator']
      peoductKeys.forEach((item) => {
        let setting = this.findSettingByKey(item)
        setting = setting ? setting : {}
        if (!_.isEmpty(setting) && !_.isEmpty(setting.content)) {
          setting.isShow = true
          setting.isShowBanner = true
          setting.isShowProduct = true

          if (_.isEmpty(setting.content.bannerPath)) {
            setting.isShowBanner = false
          }

          if (_.isEmpty(setting.content.mainProducts)) {
            setting.isShowProduct = false
          }

          if (!setting.isShowBanner && !setting.isShowProduct) {
            setting.isShow = false
          }
        } else {
          setting.isShow = false
        }
        cates.push(setting)
      })
      return cates
    }
  },
  watch: {
    showIndex(newValue, oldValue) {
      if (this.$refs.bannerBox.swiper.activeIndex != newValue) {
        this.$refs.bannerBox.swiper.slideTo(newValue, 1000, true)
      }

      let index = newValue - 4
      index = index > 0 ? index : 0
      this.$refs.bannerNameBox.swiper.slideTo(index, 500, true)
    }
  },
  methods: {
    handleSelect(cate) {
      this.activeCate = cate
    },
    bannerChange() {
      this.showIndex = this.$refs.bannerBox.swiper.activeIndex
    },
    changeBanner(index) {
      this.showIndex = index
      this.$nextTick(() => {
        this.$refs.bannerBox.swiper.autoplay.start()
      })
    },
    findSettingByKey(key) {
      const re = this.homeSettings.find((item) => {
        return item.name == key
      })
      return re ? re : {}
    },
    async getProductsBySkus(skus = []) {
      const relsQuery = {
        productSpec: { sku: JSON.stringify(skus) }
      }
      const collection = await this.$store.dispatch('activityProducts/allCollection', { relsQuery })
      let products = []
      collection.forEach((item, index) => {
        products.push(this.formatProduct(item))
      })
      return products
    },
    addCart(productInfo) {
      const cart = { productInfo, num: 1 };
      this.addToCart(cart)
    },
    formatProduct(product) {
      return {
        title: product.productSpec.specName,
        img: product.productSpec.photos.length > 0 ? product.productSpec.photos[0].url : '',
        link: {
          name: 'product-detail',
          params: {
            id: product.id
          }
        },
        marketPrice: product.productSpec.price,
        salePrice: product.price,
        watermark: isSellOut(product),
        watermarkImage: isSellOut(product) ? sallOutImagePath : '',
        tag: product.mark,
        productInfo: product,
      }
    },
    async setWeekMain() {
      const setting = this.findSettingByKey('flagship')
      if (!_.isEmpty(setting.content) && !_.isEmpty(setting.content.mainProducts)) {
        setting.products = await this.getProductsBySkus(setting.content.mainProducts)
        setting.isShow = true
      } else {
        setting.products = []
        setting.isShow = false
      }
      this.weekMain = setting
      if (!this.weekMain || !this.weekMain.isShow) {
        this.activeCate = String(this.productCates[0].id)
      }
    },
    async setProducts() {
      let skus = []
      this.productCates.forEach(item => {
        if (item.isShowProduct) {
          skus = skus.concat(item.content.mainProducts)
        }
      })
      this.products = await this.getProductsBySkus(skus)
    },
    getCateProduct(skus) {
      return this.products.filter((item) => {
        let sku = item.productInfo.productSpec.sku
        return skus.indexOf(sku) >= 0
      })
    },
    showNext() {
      this.$refs.bannerBox.swiper.slideNext()
    },
    showPrevious() {
      this.$refs.bannerBox.swiper.slidePrev()
    },
    async initPage() {
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      const query = {
        startTime: '<=' + now,
        endTime: '>=' + now,
      }
      const sorts = { weight: 'desc', id: 'desc' }
      await this.$store.dispatch('activityBanners/allCollection', { query, sorts })

      await this.$store.dispatch('activityPageSettings/getHomeSettings')
      await this.setWeekMain()
      await this.setProducts()
    }
  },
  async mounted() {
    if (!this.activity.homeShow) {
      this.$router.push('list')
    }
    await this.initPage();
    this.swiperContainer = new Swiper ('.swiper-container', {
      direction: 'horizontal', // 垂直切换选项
      loop: true, // 循环模式选项
      autoplay: true,
    })
  }

}
</script>

